import * as yup from 'yup'

const swapTerminalSchema = yup.object().shape({
    terminalTID: yup.string().required("Select a terminal"),
    pickupLocation: yup.string().required("Pick up location is required")
})

export default swapTerminalSchema;